<template>
  <v-snackbar style="z-index:100;" v-model="alert" :color="color" absolute bottom>
      {{ text }}
        <v-icon @click="close">mdi-close-circle</v-icon>
  </v-snackbar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'alert',
    computed: {
      ...mapGetters({
        status : 'alert/status',
        color  : 'alert/color',
        text   : 'alert/text'
      }),
      alert: {
        get () {
          return this.status
        },
        set (value) {
          this.setAlert({
            status : value,
            type  : 'success',
            text  : 'test',
          })
        }
      },
    },
    methods: {
      ...mapActions({
        setAlert  : 'alert/set',
      }),
      close(){
        this.setAlert({
          status : false
        })
      }
    }
}
</script>